import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Stack, Box, CardActionArea } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { fetchAllEvents } from '../../controllers/clubEventsController';
import { formatTurkeyLocalDate, parseApiLocalDateTime } from '../../utils/turkeyLocalDateTime';

const YaklaşanEtkinlikKartı = () => {
  const navigate = useNavigate();
  const [upcomingEvent, setUpcomingEvent] = useState(null);
  const [loadingEvent, setLoadingEvent] = useState(false);

  useEffect(() => {
    let active = true;
    setLoadingEvent(true);

    fetchAllEvents({ pageNumber: 1, pageSize: 1000 })
      .then(({ data }) => {
        if (!active) return;

        if (!data || !Array.isArray(data)) {
          setUpcomingEvent(null);
          return;
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const upcomingEvents = data
          .filter((event) => {
            if (!event.startDate) return false;
            const eventDate = parseApiLocalDateTime(event.startDate);
            if (!eventDate) return false;
            eventDate.setHours(0, 0, 0, 0);
            return eventDate >= today;
          })
          .sort((a, b) => {
            const dateA = parseApiLocalDateTime(a.startDate);
            const dateB = parseApiLocalDateTime(b.startDate);
            return (dateA?.getTime() || 0) - (dateB?.getTime() || 0);
          });

        if (upcomingEvents.length > 0) {
          setUpcomingEvent(upcomingEvents[0]);
        } else {
          setUpcomingEvent(null);
        }
      })
      .catch((e) => {
        if (!active) return;
        console.error('Yaklaşan etkinlik alınamadı:', e);
        setUpcomingEvent(null);
      })
      .finally(() => {
        if (active) setLoadingEvent(false);
      });

    return () => {
      active = false;
    };
  }, []);

  const formatDate = (dateString) => formatTurkeyLocalDate(dateString);

  const handleCardClick = () => {
    if (upcomingEvent?.id) {
      navigate(`/events/${upcomingEvent.id}`);
    }
  };

  return (
    <Card sx={{ border: '1px solid #f1f1f1', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
      <CardActionArea
        onClick={handleCardClick}
        disabled={!upcomingEvent?.id || loadingEvent}
        sx={{ borderRadius: '8px' }}
      >
        <CardContent sx={{ p: 2.5 }}>
          <Stack>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                backgroundColor: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 3,
              }}
            >
              <FaCalendarAlt style={{ fontSize: '20px', color: '#0E4D94' }} />
            </Box>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#666666', mb: .5 }}>
              Yaklaşan Etkinlik
            </Typography>
            {loadingEvent ? (
              <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#444444' }}>
                Yükleniyor...
              </Typography>
            ) : upcomingEvent ? (
              <Stack direction="row" spacing={2} alignItems="center">
                <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#444444', lineHeight: 1.3 }}>
                    {upcomingEvent.title || 'Etkinlik'}
                  </Typography>
                  <Typography sx={{ fontSize: '13px', fontWeight: 400, color: '#666666' }}>
                    {formatDate(upcomingEvent.startDate)}
                  </Typography>
                </Stack>
                <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                  <ChevronRightIcon sx={{ fontSize: 20, color: '#0E4D94' }} />
                </Box>
              </Stack>
            ) : (
              <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#444444' }}>
                Yaklaşan etkinlik bulunamadı
              </Typography>
            )}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default YaklaşanEtkinlikKartı;
